import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useShipmentContext } from '../../../../components/ShipmentProvider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import getShippingMethodDescription from '../../../../utils/getShippingMethodDescription';
import getShippingMethodName from '../../../../utils/getShippingMethodName';
import translations from './translations';

const ShippingMethodSection = () => {
  const intl = useIntl();
  const { method } = useShipmentContext();

  return (
    <Card style={{ height: '100%' }}>
      <CardHeader
        title={intl.formatMessage(translations.title)}
        titleTypographyProps={{ variant: 'h6' }}
      />
      {method && (
        <Grid container>
          <Grid item xs={12} md={6}>
            <List disablePadding>
              <ListItem>
                <ListItemText
                  primary={intl.formatMessage(translations.shippingMethodSection.overview.name)}
                  primaryTypographyProps={{ color: 'textSecondary', variant: 'overline' }}
                  secondary={getShippingMethodName(intl, method) ?? '-'}
                  secondaryTypographyProps={{ color: 'textPrimary', variant: 'body2' }}
                />
              </ListItem>

              <ListItem>
                <ListItemText
                  primary={intl.formatMessage(
                    translations.shippingMethodSection.overview.description,
                  )}
                  primaryTypographyProps={{ color: 'textSecondary', variant: 'overline' }}
                  secondary={getShippingMethodDescription(intl, method) ?? '-'}
                  secondaryTypographyProps={{ color: 'textPrimary', variant: 'body2' }}
                />
              </ListItem>

              <ListItem>
                <ListItemText
                  primary={intl.formatMessage(
                    translations.shippingMethodSection.overview.deliveryDuring,
                  )}
                  primaryTypographyProps={{ color: 'textSecondary', variant: 'overline' }}
                  secondary={
                    translations.shippingMethodSection.overview.deliveryDuringOptions[
                      method.delivery_during
                    ]
                      ? intl.formatMessage(
                          translations.shippingMethodSection.overview.deliveryDuringOptions[
                            method.delivery_during
                          ],
                        )
                      : method.delivery_during ?? '-'
                  }
                  secondaryTypographyProps={{ color: 'textPrimary', variant: 'body2' }}
                />
              </ListItem>
            </List>
          </Grid>
          <Grid item xs={12} md={6}>
            <List disablePadding>
              <ListItem>
                <ListItemText
                  primary={intl.formatMessage(
                    translations.shippingMethodSection.overview.isSameDay,
                  )}
                  primaryTypographyProps={{ color: 'textSecondary', variant: 'overline' }}
                  secondary={intl.formatMessage(
                    translations.shippingMethodSection.overview[method.is_same_day ? 'yes' : 'no'],
                  )}
                  secondaryTypographyProps={{ color: 'textPrimary', variant: 'body2' }}
                />
              </ListItem>

              <ListItem>
                <ListItemText
                  primary={intl.formatMessage(translations.shippingMethodSection.overview.isSunday)}
                  primaryTypographyProps={{ color: 'textSecondary', variant: 'overline' }}
                  secondary={intl.formatMessage(
                    translations.shippingMethodSection.overview[method.is_sunday ? 'yes' : 'no'],
                  )}
                  secondaryTypographyProps={{ color: 'textPrimary', variant: 'body2' }}
                />
              </ListItem>

              <ListItem>
                <ListItemText
                  primary={intl.formatMessage(
                    translations.shippingMethodSection.overview.isCarrierLocation,
                  )}
                  primaryTypographyProps={{ color: 'textSecondary', variant: 'overline' }}
                  secondary={intl.formatMessage(
                    translations.shippingMethodSection.overview[
                      method.is_carrier_location ? 'yes' : 'no'
                    ],
                  )}
                  secondaryTypographyProps={{ color: 'textPrimary', variant: 'body2' }}
                />
              </ListItem>

              <ListItem>
                <ListItemText
                  primary={intl.formatMessage(
                    translations.shippingMethodSection.overview.isNeighbourAllowed,
                  )}
                  primaryTypographyProps={{ color: 'textSecondary', variant: 'overline' }}
                  secondary={intl.formatMessage(
                    translations.shippingMethodSection.overview[
                      method.is_neighbour_allowed ? 'yes' : 'no'
                    ],
                  )}
                  secondaryTypographyProps={{ color: 'textPrimary', variant: 'body2' }}
                />
              </ListItem>
            </List>
          </Grid>
        </Grid>
      )}

      {!method && (
        <CardContent>
          <Typography variant="body2">
            {intl.formatMessage(translations.shippingMethodSection.emptyMessage)}
          </Typography>
        </CardContent>
      )}
    </Card>
  );
};

export default ShippingMethodSection;
